import { green, red, yellow } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

// A custom theme for this app

const theme = createTheme({
  typography: {
    fontFamily: '"Sarabun", "Helvetica", "Arial", sans-serif',
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 640,
      md: 768,
      lg: 1024,
      xl: 1280,
    },
  },

  palette: {
    amber: {
      main: '#ffc107',
    },
    // primary: {
    //   main: '#4FA893',
    //   light: '#96BAFF',
    //   dark: '#63b6a2;',
    // },
    cyan: {
      main: '#00bcd4',
    },
    secondary: {
      main: '#fff',
    },
    indigo: {
      main: '#3f51b5',
    },
    error: {
      main: red.A400,
    },
    warning: {
      main: yellow[800],
    },
    success: {
      main: green[500],
    },
    lightGreen: {
      main: '#6FBAE9',
      text: '#fff',
    },
    gray: {
      main: '#9e9e9e',
    },
    background: {
      default: '#007CC2;',
    },
  },
});

export default theme;
